export default __webpack_public_path__ + "static/Metal_Wall-3dbacb7c27655ed95a97bfe19d5cc18e.png";